<ng-container *ngIf="worker">
  <ng-container *transloco="let t">
    <c-container>
      <c-row>
        <c-col>
          <h5>{{ t('Manage Your iHelp Device') }}</h5>
          <br/>
          {{ t('iHelp Devices can now be linked to OK Alone. This means you can request help using your iHelp device.') }}
          <br/>
          {{ t('Note: This is a new feature. Please email us at customer.support@ok-alone.com if you want to use your iHelp device') }}
          <br/>
          <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()">
            <div class="form-group row mb-2" >
              <label class="col-4 col-form-label text-start text-sm-end"><i class="fa-solid fa-location-pin"></i> {{ t('IMEI') }}</label>
              <div class="col-8">
                <input
                  [formControlName]="'ihelp'"
                  cFormControl
                  placeholder="00000000000000"
                />
                {{ t('Enter your iHelp device IMEI number, e.g') }} 891878056722458
              </div>
            </div>
            <c-row>
              <c-col xs="6" class="mt-3">
                <button cButton class="px-4 text-white btn-info" type="submit">
                  <i class="fa-solid fa-check"></i> {{ t('Update your iHelp Device') }}
                </button>
              </c-col>
            </c-row>
          </form>
          <hr/>
          <div>
            <h5>{{ t('Learn How to Connect your iHelp Device') }}</h5>
            {{ t('To learn how to connect your iHelp Device to work with OK Alone please follow the link below.') }}
            <a href="https://okalone.zendesk.com/hc/en-gb/articles/35352563114001-How-to-Set-Up-Your-iHelp-Mini-Device" target="_new">https://okalone.zendesk.com/hc/en-gb/articles/35352563114001-How-to-Set-Up-Your-iHelp-Mini-Device</a>
          </div>
        </c-col>
        <c-col>
          <img src="assets/images/ihelp-mini.png" alt="iHelp IMEI Example" class="img-thumbnail img-responsive pull-right"/>
        </c-col>
      </c-row>
    </c-container>
  </ng-container>
</ng-container>
